import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {UserType} from '../../types/UserType';
import { PURGE } from 'redux-persist';

type UserState = {
  user: UserType | null; 
  rememberMe: boolean;
  displayName: string;
};

const initialState: UserState = {
  user: null, 
  rememberMe: false,
  displayName: 'User'
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<UserType>) => {
      state.user = action.payload;
    },
    logOut: (state) => {
      state.user = null;
      state.rememberMe = false;
    },
    setRememberMe: (state, action: PayloadAction<boolean>) => {
      state.rememberMe = action.payload;
    },
    setDisplayName: (state, action: PayloadAction<string>) => {
            state.displayName = action.payload;
          },
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => initialState);
  },
});

export const {setUser, logOut, setRememberMe, setDisplayName} = userSlice.actions;

export {userSlice};